<div class="card dialog-card">
  <div class="card-header">
    <h3 class="header-title">
      {{ "administration.inviteMember.title" | translate }}
    </h3>

    <button type="button" class="close-button" (click)="dialogRef.close()" [attr.aria-label]="'common.close' | translate">
      <lucide-angular name="x" [size]="20"></lucide-angular>
    </button>
  </div>

  <!-- SUCCESS STATE -->
  <div class="success-card" *ngIf="isSuccess">
    <div class="success-icon">
      <lucide-angular name="check" [size]="20"></lucide-angular>
    </div>

    <div class="success-content">
      <p class="success-title">
        {{ "administration.inviteMember.success.title" | translate: { email: successEmail } }}
      </p>

      <p class="success-message">
        {{ "administration.inviteMember.success.message" | translate }}
      </p>
    </div>
  </div>

  <form [formGroup]="inviteForm" (ngSubmit)="submit()" class="card-content">
    <!-- Email Field -->
    <div class="field">
      <label class="label" for="email">{{ "administration.inviteMember.email" | translate }}</label>
      <input
        id="email"
        class="form-input"
        type="email"
        formControlName="email"
        (input)="emailAlreadyMember = false; invitationAlreadyPending = false"
      />

      <div class="error-message" *ngIf="inviteForm.controls.email.touched && inviteForm.controls.email.errors?.['required']">
        <span>{{ "common.required" | translate }}</span>
      </div>
      <div class="error-message" *ngIf="inviteForm.controls.email.touched && inviteForm.controls.email.errors?.['pattern']">
        <span>{{ "administration.emailInvalid" | translate }}</span>
      </div>

      <div class="error-message" *ngIf="emailAlreadyMember">
        <span>{{ "administration.inviteMember.emailAlreadyMember" | translate }}</span>
      </div>

      <div class="error-message" *ngIf="invitationAlreadyPending">
        <span>{{ "administration.inviteMember.invitationAlreadyPending" | translate }}</span>
      </div>
    </div>

    <!-- Role Field -->
    <div class="field">
      <label class="label" for="role">{{ "administration.inviteMember.role" | translate }}</label>
      <select id="role" class="form-input" formControlName="role" (change)="superAdminOnly = false">
        <option *ngFor="let role of roles" [value]="role">
          {{ "administration.role." + role | translate }}
        </option>
      </select>

      <div class="error-message" *ngIf="inviteForm.controls.role.touched && inviteForm.controls.role.errors?.['required']">
        <span>{{ "common.required" | translate }}</span>
      </div>

      <div class="error-message" *ngIf="superAdminOnly">
        <span>{{ "administration.inviteMember.superAdminOnly" | translate }}</span>
      </div>
    </div>

    <!-- Actions -->
    <div class="form-actions">
      <button class="button-blue" type="submit" [disabled]="inviteForm.disabled">
        {{ "administration.inviteMember.submit" | translate }}
      </button>
    </div>
  </form>
</div>
